// extracted by mini-css-extract-plugin
module.exports = {"rounded":"_2onibHzpue60u3OT3Ag01q","right-inner-addon":"_3NSBKBEfCeooGG9jLq1Tc7","left-inner-addon":"_2rJONo0zCyBpq-xkoT1ibA"};